import { useState } from 'react';
import useFetch from '../hooks/useFetch'
import { apiWrapper } from './dataHookUtils'

export default () => {
  const [isLoading, setIsLoading] = useState()

  const [trainerEventReminders, setTrainerEventReminders] = useState()
  const [composeTrainerEventReminderEmail, setComposeTrainerEventReminderEmail] = useState()
  const [runTrainerEventReminderEmail, setRunTrainerEventReminderEmail] = useState()

  const [attendeesForEventReminders, setAttendeesForEventReminders] = useState()
  const [composeAttendeesEventReminderEmail, setComposeAttendeesEventReminderEmail] = useState()
  const [runAttendeeEventReminderEmail, setRunAttendeeEventReminderEmail] = useState()

  const [attendeesForEventCertificates, setAttendeesForEventCertificates] = useState()
  const [composeAttendeesEventCertificatesEmail, setComposeAttendeesEventCertificatesEmail] = useState()
  const [runAttendeeEventCertificatesEmail, setRunAttendeeEventCertificatesEmail] = useState()
  
  const [sendEmail, setSendEmail] = useState()

  const fetch = useFetch()

  const postHeaders = { "Content-Type": "application/json" }
  const createPostOptions = (data) => ({
    method: 'POST',
    headers: postHeaders,
    body: data ? JSON.stringify(data) : undefined
  })

  const fetchTrainerEventReminders = async (data) => {
    try {
      setIsLoading(true)
      const result = await apiWrapper({
        fetch,
        url: `events/event/jobs/trainers`
      });
      setTrainerEventReminders(result)
      return result
    } catch (e) {
      setTrainerEventReminders()
    } finally {
      setIsLoading(false)
    }
  }

  const fetchComposeTrainerEventReminderEmail = async (data) => {
    try {
      setIsLoading(true)
      const result = await apiWrapper({
        fetch,
        url: `events/event/jobs/trainers/email`,
        options: createPostOptions(data)
      });
      setComposeTrainerEventReminderEmail(result)
      return result
    } catch (e) {
      setComposeTrainerEventReminderEmail()
    } finally {
      setIsLoading(false)
    }
  }

  const fetchRunTrainerEventReminderEmail = async (data) => {
    try {
      setIsLoading(true)
      const result = await apiWrapper({
        fetch,
        url: `events/event/jobs/trainers/run`,
        options: createPostOptions(data)
      });
      setRunTrainerEventReminderEmail(result)
      return result
    } catch (e) {
      setRunTrainerEventReminderEmail()
    } finally {
      setIsLoading(false)
    }
  }

  const fetchAttendeesForEventReminders = async (filters = {}) => {
    try {
      setIsLoading(true);
      const response = await fetch(`events/event/jobs/attendees`, { method: 'GET' })
      const jsonData = await response.json()
      setAttendeesForEventReminders(jsonData.error ? [] : jsonData)
      setIsLoading(false)
    } catch (e) {
      console.log(e)
      setAttendeesForEventReminders([])
      setIsLoading(false)
    }
  }

  const fetchComposeAttendeeEventReminderEmail = async (data) => {
    try {
      setIsLoading(true)
      const result = await apiWrapper({
        fetch,
        url: `events/event/jobs/attendees/email`,
        options: createPostOptions(data)
      });
      setComposeAttendeesEventReminderEmail(result)
      return result
    } catch (e) {
      setComposeAttendeesEventReminderEmail()
    } finally {
      setIsLoading(false)
    }
  }

  const fetchRunAttendeeEventReminderEmail = async (data) => {
    try {
      setIsLoading(true)
      const result = await apiWrapper({
        fetch,
        url: `events/event/jobs/attendees/run`,
        options: createPostOptions(data)
      });
      setRunAttendeeEventReminderEmail(result)
      return result
    } catch (e) {
      setRunAttendeeEventReminderEmail()
    } finally {
      setIsLoading(false)
    }
  }

  const fetchAttendeesForEventCertificates = async (filters = {}) => {
    try {
      setIsLoading(true);
      const response = await fetch(`events/event/jobs/attendeeCertificates`, { method: 'GET' })
      const jsonData = await response.json()
      setAttendeesForEventCertificates(jsonData.error ? [] : jsonData)
      setIsLoading(false)
    } catch (e) {
      console.log(e)
      setAttendeesForEventCertificates([])
      setIsLoading(false)
    }
  }

  const fetchComposeAttendeeEventCertificateEmail = async (data) => {
    try {
      setIsLoading(true)
      const result = await apiWrapper({
        fetch,
        url: `events/event/jobs/attendeeCertificates/email`,
        options: createPostOptions(data)
      });
      setComposeAttendeesEventCertificatesEmail(result)
      return result
    } catch (e) {
      setComposeAttendeesEventCertificatesEmail()
    } finally {
      setIsLoading(false)
    }
  }

  const fetchRunAttendeeEventCertificateEmail = async (data) => {
    try {
      setIsLoading(true)
      const result = await apiWrapper({
        fetch,
        url: `events/event/jobs/attendeeCertificates/run`,
        options: createPostOptions(data)
      });
      setRunAttendeeEventCertificatesEmail(result)
      return result
    } catch (e) {
      setRunAttendeeEventCertificatesEmail()
    } finally {
      setIsLoading(false)
    }
  }

  const fetchSendEmail = async (data) => {
    try {
      setIsLoading(true)
      const result = await apiWrapper({
        fetch,
        url: `events/event/jobs/email`,
        options: createPostOptions(data)
      });
      setSendEmail(result)
      return result
    } catch (e) {
      setSendEmail()
    } finally {
      setIsLoading(false)
    }
  }

  return {
    isLoading,
    
    trainerEventReminders,
    fetchTrainerEventReminders,
    composeTrainerEventReminderEmail,
    fetchComposeTrainerEventReminderEmail,
    runTrainerEventReminderEmail,
    fetchRunTrainerEventReminderEmail,

    attendeesForEventReminders,
    fetchAttendeesForEventReminders,
    composeAttendeesEventReminderEmail,
    fetchComposeAttendeeEventReminderEmail,
    runAttendeeEventReminderEmail,
    fetchRunAttendeeEventReminderEmail,

    attendeesForEventCertificates,
    fetchAttendeesForEventCertificates,
    composeAttendeesEventCertificatesEmail,
    fetchComposeAttendeeEventCertificateEmail,
    runAttendeeEventCertificatesEmail,
    fetchRunAttendeeEventCertificateEmail,

    sendEmail,
    fetchSendEmail
  }
}